import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../lib/auth";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/admin/login", { replace: true });
      return;
    }
    const sessionId = match[1];

    (async () => {
      try {
        const res = await api.post(
          "/auth/session",
          { session_id: sessionId },
          { withCredentials: true }
        );
        setUser(res.data);
        // Clean URL & redirect
        window.history.replaceState({}, "", "/admin");
        navigate("/admin", { replace: true, state: { user: res.data } });
      } catch {
        navigate("/admin/login?error=session_invalid", { replace: true });
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#FAF9F6]" data-testid="auth-callback">
      <div className="text-center">
        <p className="text-xs tracking-[0.3em] uppercase text-[#9E4735] font-body mb-4">Connexion en cours</p>
        <p className="font-serif text-3xl text-[#1A1A1A]">Authentification…</p>
      </div>
    </div>
  );
}
